/**
 * Overlay mode classification — panels and extension read from ONE source
 * (the score graphic keeps its own local copy: graphics-src/score/src/main.ts
 * TITRE_MODES — if you change it, keep the two in sync).
 *
 * SKORE model: the scoreboard is driven by the `table` radio, the littles
 * (extra_little_mode) ride ON TOP of it, while the titres (the titre_lower
 * family) are independent lower-thirds — they neither force the scoreboard
 * on nor hide it.
 */

/** Independent lower-third titres — referees/VAR/coach ID. */
export const TITRE_OVERLAY_MODES: ReadonlySet<string> = new Set([
  "little_names_ref",
  "little_names_ref_helper",
  "little_names_var",
  "coach_id_home",
  "coach_id_away",
  "player_stat",
]);

/** Little modes that ride ON TOP of the scoreboard (SKORE extra_little_mode).
 *  The graphic forces the scoreboard on when entering these modes — when they
 *  go off air the bare scoreboard remains, never an empty screen. */
export function isTableauSubMode(id: string | null | undefined): boolean {
  return !!id && id.startsWith("little_") && !TITRE_OVERLAY_MODES.has(id);
}

/** Transient banner modes — members of a self-closing chain; auto
 *  sponsor/extra-time must not interrupt them. */
export function isTransientOverlayMode(id: string | null | undefined): boolean {
  return !!id && (id.startsWith("little_event_") || id.startsWith("little_card_"));
}

/** Fullscreen boards — the SKORE `table` radio. The panel toggle semantics and
 *  the server-side grid swap both use this one list. */
export const FULLSCREEN_OVERLAY_MODES: ReadonlySet<string> = new Set([
  "big",
  "matchid",
  "stadium",
  "stats",
  "weather",
  "custom",
  "roster_home",
  "roster_away",
  "reserve_home",
  "reserve_away",
  "tournament_1_8",
  "tournament_9_16",
  "player_compare_pre",
  "player_compare_ht",
]);

/** In SKORE the grid is also in the `table` radio group: when the scoreboard
 *  or a fullscreen board comes on, the on-air grid goes off. */
export function takesOverGrid(mode: string | null | undefined): boolean {
  return !!mode && (mode === "scoreboard" || FULLSCREEN_OVERLAY_MODES.has(mode));
}
